import React from 'react'; 
import { TbWifiOff } from 'react-icons/tb';

const Offline = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '100vh', width: '100vw' }}>
            <div className="d-flex flex-column align-items-center justify-content-center min-h-screen bg-gray-100">
                <TbWifiOff size={100} className='mb-3 super-admin-text' />
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#333' }}>
                    No Internet Connection
                </h2>
                <p style={{ color: '#666', marginBottom: '1.5rem' }}>
                    Oops! It looks like you're offline. Check your connection and try again.
                </p>
            </div>
        </div>
    );
};

export default Offline;